import styled from './ProgressBar.module.scss'
import { observer } from 'mobx-react-lite';
import { useStore } from '../../module/rootStore';
import { useEffect, useRef } from 'react';


const ProgressBar = () => {

  const progressBarRef = useRef<HTMLDivElement>(null)
  const { progressSettings, currentPercent } = useStore().ProgressStore
  const { currentStep } = useStore().StepsStore

  useEffect(() => {
    let flag = false
    const pageYOffsetHandler = () => {
      const progressBarBounding = progressBarRef.current?.getBoundingClientRect() || { y: 0, top: 0 }
      const checkTop = progressBarBounding.y + progressBarBounding.top
      if (checkTop <= 0 && !flag) {
        progressBarRef.current?.classList.add(styled.shadow)
        flag = true
      } else if (checkTop > 0 && flag) {
        progressBarRef.current?.classList.remove(styled.shadow)
        flag = false
      }

    }
    if (document.body.scrollWidth < 790) {
      window.addEventListener('scroll', pageYOffsetHandler)
    }

    return () => {
      window.removeEventListener('scroll', pageYOffsetHandler)
    }
  }, [])

  return (
    <div className={styled.container}>
      <div className={`${styled.wrapper} ProgressBar_wrapper`} ref={progressBarRef} >
        <div className={styled.title} >
          <span className={styled.percent_green}>
            {progressSettings[currentStep]?.titlePercent} &nbsp;
          </span>
          <span>
            {progressSettings[currentStep]?.title}
          </span>
        </div>
        <div className={`${styled.bar} ProgressBar_bar`} >
          <div
            className={styled.progress_stripe}
            style={{ width: `${progressSettings[currentStep]?.maxPersent}%` }}
          />
          <div
            className={styled.progress_fill}
            style={{ width: `${currentPercent}%` }}
          />
        </div>
        <div className={styled.title} >
          <span className={styled.percent}>
            {progressSettings[currentStep]?.footerPercent} &nbsp;
          </span>
          <span>
            {progressSettings[currentStep]?.footer}
          </span>
        </div>
      </div>
    </div>
  )
}

export default observer(ProgressBar)